import { db } from '../database';

export interface CrudOperations<T> {
  loadItem: (id: number) => Promise<T | undefined>;
  saveItem: (item: Omit<T, 'id' | 'createdAt' | 'updatedAt'>) => Promise<number>;
  updateItem: (id: number, item: Omit<T, 'id' | 'createdAt' | 'updatedAt'>) => Promise<void>;
}

export function createCrudOperations<T>(tableName: keyof typeof db): CrudOperations<T> {
  const table = db[tableName] as any;
  
  return {
    loadItem: (id: number) => table.get(id),
    saveItem: async (item: Omit<T, 'id' | 'createdAt' | 'updatedAt'>) => {
      return await table.add({
        ...item,
        createdAt: new Date(),
        updatedAt: new Date(),
      });
    },
    updateItem: async (id: number, item: Omit<T, 'id' | 'createdAt' | 'updatedAt'>) => {
      await table.update(id, {
        ...item,
        updatedAt: new Date(),
      });
    },
  };
}